import { Navigate, useRouteError } from 'react-router';

import { OrderNotFoundError } from '../controller/routes/error.ts';
import { ToolkitGenericFallback } from './ToolkitGenericFallback.tsx';

export const OrderErrorBoundary = () => {
  const error = useRouteError();

  if (error instanceof OrderNotFoundError) {
    return <Navigate to="/orders" />;
  } else {
    console.error(error);
  }

  return <ToolkitGenericFallback />;
};
